// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__vPl7R","paramInput":"JobSimulator_paramInput__3Fu7c","input":"JobSimulator_input__2K0GO"};